import React, { useEffect } from "react";
import "./component.css";
import "./PalletGroup/palletGroupAssignment.css";
import { useLocation, useNavigate } from "react-router-dom";
import { PullQuote } from "@nike/nike-design-system-components";
import Header from "../components/Header";
import PalletGroupAssignmentContainer from "../containers/PalletGroupAssignmentContainer";
import {
  ROUTE_HOME,
  ROUTE_PALLET_GROUP_ASSIGNMENT,
} from "../constants/routes";
import { DC_SITE_CODE } from "../constants/site";

function RoutingPanel(props) {
  const adGrps = props.adGroup;
  const location = useLocation();
  const navigate = useNavigate();
  const onAssignmentRoute =
    location.pathname === ROUTE_PALLET_GROUP_ASSIGNMENT;

  useEffect(() => {
    if (onAssignmentRoute && location.state == null) {
      navigate(ROUTE_HOME, { replace: true });
    }
  }, [onAssignmentRoute, location.state, navigate]);

  let content = null;
  let showTabBar = false;

  if (location && location.state != null) {
    const dcSite = location.state.dc;
    const dbAdGrps = location.state.adGroups;

    if (dcSite !== DC_SITE_CODE) {
      content = (
        <div className="pg-message-wrap">
          <PullQuote
            className="h1"
            text="This application is only available for the ELCLKDL DECON site."
          />
        </div>
      );
    } else {
      let authorized = false;
      if (undefined !== adGrps && undefined !== dbAdGrps && dbAdGrps.length > 0) {
        dbAdGrps.forEach((resData) => {
          if (adGrps.includes(resData)) {
            authorized = true;
          }
        });
      }

      if (authorized && onAssignmentRoute) {
        showTabBar = true;
        content = <PalletGroupAssignmentContainer siteCode={dcSite} />;
      } else {
        content = (
          <div className="pg-message-wrap">
            <PullQuote
              className="h1"
              text="You are not authorised to view this page. Please contact administrator."
            />
          </div>
        );
      }
    }
  }

  return (
    <div className="pg-shell">
      <Header
        handleLogout={props.handleLogout}
        displayLogout={props.displayLogout}
        dcLabel={location.state?.dcLabel}
      />
      {showTabBar && (
        <nav className="pg-tab-bar" aria-label="Main navigation">
          <span className="pg-tab-bar__tab pg-tab-bar__tab--active">
            PALLET GROUP ASSIGNMENT
          </span>
        </nav>
      )}
      <main className={`pg-main${showTabBar ? " pg-main--workspace" : ""}`}>
        {content}
      </main>
    </div>
  );
}

export default RoutingPanel;
